import { __assign } from "tslib";
var VeltService = /** @class */ (function () {
    function VeltService() {
    }
    var _a;
    _a = VeltService;
    VeltService.selectedCommentsMap = new Map();
    VeltService.subscribers = new Map();
    VeltService.isSubscribed = false;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    VeltService.getCommentElement = function () {
        try {
            var velt = window.Velt;
            if (velt === null || velt === void 0 ? void 0 : velt.getCommentElement) {
                return velt.getCommentElement();
            }
            return null;
        }
        catch (error) {
            _a.catchError('Error getting comment element:', error);
            return null;
        }
    };
    VeltService.addManualComment = function (_b) {
        var context = _b.context, location = _b.location;
        try {
            var commentElement = _a.getCommentElement();
            if (!commentElement)
                return Promise.resolve(null);
            return commentElement.addManualComment({ context: context, location: location });
        }
        catch (error) {
            _a.catchError('Error adding manual comment:', error);
            return Promise.resolve(null);
        }
    };
    VeltService.updateContext = function (_b) {
        var annotationId = _b.annotationId, context = _b.context;
        try {
            var commentElement = _a.getCommentElement();
            if (!commentElement)
                return Promise.resolve(null);
            return commentElement.updateContext(annotationId, context);
        }
        catch (error) {
            _a.catchError('Error updating context:', error);
        }
    };
    VeltService.subscribeToSelectedCommentsMap = function (id, subscriber) {
        try {
            _a.subscribeToSelectedAnnotationsMapSingleton();
            _a.subscribers.set(id, subscriber);
        }
        catch (error) {
            _a.catchError('Error subscribing to selected comments map:', error);
        }
    };
    VeltService.unsubscribeFromSelectedCommentsMap = function (id) {
        try {
            _a.subscribers.delete(id);
        }
        catch (error) {
            _a.catchError('Error unsubscribing from selected comments map:', error);
        }
    };
    VeltService.catchError = function (message, otherProperties) {
        var _b;
        try {
            var url = 'https://api.velt.dev/sa';
            var properties = {};
            if (otherProperties && typeof otherProperties === 'object') {
                properties = __assign(__assign({}, properties), otherProperties);
            }
            if (message) {
                properties.message = message;
            }
            properties.sdkVersion = (_b = window.Velt) === null || _b === void 0 ? void 0 : _b.version;
            var body = {
                type: 'track',
                data: {
                    event: 'tiptapVeltCommentsError',
                    properties: properties,
                },
            };
            //   fetch(url, {
            //     method: 'POST',
            //     headers: {
            //       'Content-Type': 'application/json',
            //     },
            //     body: JSON.stringify(body),
            //   });
        }
        catch (error) {
            // handle error here
        }
    };
    VeltService.subscribeToSelectedAnnotationsMapSingleton = function () {
        var _b;
        try {
            if (_a.isSubscribed) {
                return;
            }
            var commentElement = _a.getCommentElement();
            if (commentElement && typeof (commentElement === null || commentElement === void 0 ? void 0 : commentElement.getSelectedComments) === 'function') {
                (_b = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getSelectedComments()) === null || _b === void 0 ? void 0 : _b.subscribe(function (comments) {
                    var selectedCommentsMap = new Map();
                    comments === null || comments === void 0 ? void 0 : comments.forEach(function (comment) {
                        if (comment === null || comment === void 0 ? void 0 : comment.annotationId) {
                            selectedCommentsMap.set(comment === null || comment === void 0 ? void 0 : comment.annotationId, true);
                        }
                    });
                    // Check if the maps are different
                    var areMapsEqual = function (map1, map2) {
                        if (map1.size !== map2.size)
                            return false;
                        for (var _i = 0, map1_1 = map1; _i < map1_1.length; _i++) {
                            var _b = map1_1[_i], key = _b[0], value = _b[1];
                            if (map2.get(key) !== value)
                                return false;
                        }
                        return true;
                    };
                    // Skip update if maps are equal
                    if (areMapsEqual(selectedCommentsMap, _a.selectedCommentsMap || new Map())) {
                        return;
                    }
                    _a.updateSelectedCommentsMap(selectedCommentsMap);
                });
                _a.isSubscribed = true;
            }
        }
        catch (error) {
            return new Map();
        }
    };
    VeltService.updateSelectedCommentsMap = function (selectedCommentsMap) {
        try {
            _a.selectedCommentsMap = selectedCommentsMap;
            _a.subscribers.forEach(function (subscriber) {
                if (typeof subscriber === 'function') {
                    subscriber(_a.selectedCommentsMap);
                }
            });
        }
        catch (error) {
            _a.catchError('Error updating selected comments map:', error);
        }
    };
    return VeltService;
}());
export { VeltService };
